import {AfterViewInit, ChangeDetectionStrategy, Component, computed, ElementRef, input, OnDestroy} from "@angular/core";
import {KortSamlingRegister} from "web-ng2/delt/komponenter/kort/kort-samling/kort-samling";
import {erIkkeNil, erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {scrollTilNærmestAvToppBunn} from "web-ng2/delt/dom/scrollIntoView";

@Component({
    selector: 'kort',
    template: '<ng-content/>',
    styleUrl: 'kort.scss',
    host: {
        '[class.er-aktiv]': 'erAktiv()',
        '[class.er-annen-aktiv]': 'erAnnenAktiv()',
        '[class.er-ingen-aktiv]': 'erIngenAktiv()',
    },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KortKomponent implements AfterViewInit, OnDestroy {

    /** id som unikt identifiserer dette kortet blant alle kort i en {@link KortSamlingKomponent} */
    id = input.required<string>();

    erAktiv = computed(()=> erIkkeNil(this.kortSamlingRegister.aktivtKort()) && this.kortSamlingRegister.aktivtKort() === this.id());
    erAnnenAktiv = computed(()=> erIkkeNil(this.kortSamlingRegister.aktivtKort()) && this.kortSamlingRegister.aktivtKort() !== this.id());
    erIngenAktiv = computed(()=> erNil(this.kortSamlingRegister.aktivtKort()));

    constructor(private kortSamlingRegister: KortSamlingRegister, private el: ElementRef<HTMLElement>) {
    }

    setSomAktiv(){
        this.kortSamlingRegister.aktivtKort.set(this.id());
    }

    setSomAktivOgSkrollTil(){
        this.setSomAktiv();
        this.skrollTil();
    }

    setSomIkkeAktiv() {
        this.kortSamlingRegister.aktivtKort.set(null);
    }

    skrollTil(){
        //venter litt før vi skroller slik at eventuelle endringer i gui som følge av aktivering rekker å bli tegnet ut
        scrollTilNærmestAvToppBunn(this.el.nativeElement, 100);
    }

    ngAfterViewInit(): void {
        //gjør dette i ngAfterViewInit fremfor i konstruktør da vi ikke ønsker å reg kort før id er tilgjengelig
        //kall til this.id() vil feile dersom gjort i konstruktør..
        this.kortSamlingRegister.registrerKort(this);
    }

    ngOnDestroy(): void {
        this.kortSamlingRegister.fjernKort(this);
    }

}
